import styled from '@emotion/styled';

export const ListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
`;
